import { FC } from 'react';
import { StyledLabelWithTooltip, StyledLineItem } from './startup-cost-item.styled';
import { ToolTipContent } from '../../../shared/tool-tip-content/tool-tip-content.component';
import { formatPrice } from '../../../../utils/helpers';
import { Abbreviations } from '../../../../constants/units-and-abbreviations';
import { useMediaQuery } from '../../../../hooks/use-media-query';

type IProps = {
    price: number | null;
    label?: string;
    tooltip?: string;
};

export const StartupCostItem: FC<IProps> = ({ price, label, tooltip }) => {
    const isMobile = useMediaQuery({ target: 'tablet' });
    if (!price) return null;

    return (
        <>
            <StyledLineItem>
                {tooltip ? (
                    <>
                        <StyledLabelWithTooltip>
                            {label}
                            <ToolTipContent openDirection={isMobile && (label ?? '').length > 30 ? 'left' : 'right'}>{tooltip}</ToolTipContent>
                        </StyledLabelWithTooltip>
                        <span>
                            {formatPrice(price)} {Abbreviations.KR}
                        </span>
                    </>
                ) : (
                    <>
                        {label}
                        <span>
                            {formatPrice(price)} {Abbreviations.KR}
                        </span>
                    </>
                )}
            </StyledLineItem>
        </>
    );
};
